export { CITATION_MARKER_SOURCE, createCitationPattern } from "./citation-pattern";
export type { CitationMatch } from "./citation-utils";
export { CITATION_PATTERN, processCitationPlaceholders, renderTextWithCitations } from "./citation-utils";
export { getCitationHighlights, getEncodedHighlightsWithPage, getHighlightsFromEnrichedLines } from "./citationHelpers";
export type { SerializableHighlight } from "./highlightSerializer";
export { decodeHighlight, encodeHighlight } from "./highlightSerializer";
export { dedentIndentedCodeBlocks } from "./indented-code-blocks";
export type { PageLinkOptions } from "./page-reference-utils";
export { formatPageReferences } from "./page-reference-utils";
export type { ReplacementRule } from "./replacement-utils";
export { processReplacements } from "./replacement-utils";
export { decodeTagOverlayId, encodeTagOverlayId } from "./tagOverlayIdSerializer";
